<div class="actionwrapper">
    <div class="actions">
        <button mat-raised-button color="primary" (click)="addItem()">
            <mat-icon>add</mat-icon>
            Add new vendor config
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="vendorSlug">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor slug</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.vendorSlug}}</td>
  </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
      <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
    <mat-menu #menu="matMenu">
      <ng-template matMenuContent let-item="item">
        <button mat-menu-item (click)="editItem(item)">Edit</button>
        <button mat-menu-item (click)="addItem(item)">Duplicate</button>
        <button mat-menu-item (click)="deleteItem(item)">Remove</button>
      </ng-template>
    </mat-menu>
</table>
